import {
  Box,
  Button,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Image,
} from '@/ui';

import heartExclamation from './heart-exclamation.png';

type CopyLinkModalProps = {
  modalTrigger: 'blur' | 'update';
  isOpen: boolean;
  onClose?: () => void;
  onConfirm?: () => void;
};

export const CopyLinkModal = ({
  modalTrigger,
  isOpen,
  onClose,
  onConfirm,
}: CopyLinkModalProps) => {
  const handleCancel = () => {
    onClose?.();
  };

  const handleConfirm = () => {
    onConfirm?.();
  };

  const message =
    modalTrigger !== 'blur'
      ? 'When you choose a new URL, the current one will no longer work. Change your current URL?'
      : 'Are you sure you want to exit without saving your changes?';
  const confirmationMsg = modalTrigger !== 'blur' ? 'Yes, change' : 'Yes, exit';

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      returnFocusOnClose={false}
      variant="primary"
      onClose={handleCancel}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Flex
            direction="column"
            gap="6"
            maxW={'400px'}
            mx="auto"
            textAlign="center"
          >
            <Box mx="auto">
              <Image src={heartExclamation} w={{ base: '65px' }} />
            </Box>
            <Heading fontSize="2xl">{message}</Heading>
          </Flex>
          <Flex gap="4" justifyContent="center" mt="8">
            <Button
              borderColor={'gray.500'}
              variant="outline"
              onClick={handleCancel}
            >
              Cancel
            </Button>
            <Button colorScheme="red" onClick={handleConfirm}>
              {confirmationMsg}
            </Button>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
